import styled from 'styled-components';

const StyledHr = styled.hr`
  border-top: 1.5px solid
    ${({ color, theme }) => (color ? theme[color] : theme.inputBorder)};
  margin: 5px 0;
  opacity: 1;
`;

export default StyledHr;
